import React from "react";
import DataTableComponent from "../../commonComponents/DataTableComponent";

const DisplayFolder = ({ displayData }) => {

	return (
		<div className="pd-25">
			<div className="mg-l-50 mg-r-50 mg-b-25">
				<div className="card-file-thumb tx-primary">
					<i className={`far ${displayData.icon}`}></i>
				</div>
			</div>
			<h6 className="text-center">{displayData.title}</h6>

			{ displayData.information ?
				<React.Fragment>
					<h6 className="mg-t-25"><span>Information</span></h6>
					<hr className="mg-y-5"></hr>

					{Object.values(displayData.information).map(function (innerData) {
						return <span style={{ display: 'block' }}>{innerData}</span>
					})}
				</React.Fragment>
				: null
			}

			{displayData.tableData ?
				<>
					<h6 className="mg-t-25"><span>{displayData.tableHeader}</span></h6>
					<DataTableComponent tableData={displayData.tableData} columnData={displayData.columnData} paginationStatus={false} />
				</>
				: null}
		</div>
	);
};

export default DisplayFolder;